module.exports = __webpack_public_path__ + "static/media/OLIVIA_CARPENTIER_PHOTO.f35821c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/OLIVIA_CARPENTIER_PHOTO.jpg
// module id = 250
// module chunks = 0